
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/[...slug]",
      function () {
        return require("private-next-pages/pt-br/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/[...slug]"])
      });
    }
  